import { User } from '@core/auth/hooks/use-profile/use-profile.hook.types'

import { getUserPermission } from '../get-user-permission/get-user-permission'
import { getUserPermissionGroup } from '../user-permissions/user-permissions.types'

export const getHavePermissionGroup = (user: User) => {
  const permission = getUserPermission(user)

  if (!permission) return undefined
  return getUserPermissionGroup[permission]
}
